var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppStoreGoogle4D63C31A3E(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 40,
    viewBox: "0 0 135 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "app-store-google-4d63c31a3e",
    clipPath: "url(#clip0_135_1397)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M130 40H5C2.2 40 0 37.8 0 35V5C0 2.2 2.2 0 5 0H130C132.8 0 135 2.2 135 5V35C135 37.8 132.8 40 130 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M130 0.8C132.3 0.8 134.2 2.7 134.2 5V35C134.2 37.3 132.3 39.2 130 39.2H5C2.7 39.2 0.8 37.3 0.8 35V5C0.8 2.7 2.7 0.8 5 0.8H130ZM130 0H5C2.2 0 0 2.3 0 5V35C0 37.8 2.2 40 5 40H130C132.8 40 135 37.8 135 35V5C135 2.3 132.8 0 130 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M47.4 10.1999C47.4 10.9999 47.2 11.6999 46.7 12.1999C46.1 12.7999 45.4 13.0999 44.5 13.0999C43.6 13.0999 42.9 12.7999 42.3 12.1999C41.7 11.5999 41.4 10.8999 41.4 9.9999C41.4 9.0999 41.7 8.3999 42.3 7.7999C42.9 7.1999 43.6 6.8999 44.5 6.8999C44.9 6.8999 45.3 6.9999 45.7 7.1999C46.1 7.3999 46.4 7.5999 46.6 7.8999L46.1 8.3999C45.7 7.8999 45.2 7.6999 44.5 7.6999C43.9 7.6999 43.3 7.8999 42.9 8.3999C42.4 8.7999 42.2 9.3999 42.2 10.0999C42.2 10.7999 42.4 11.3999 42.9 11.7999C43.4 12.1999 43.9 12.4999 44.5 12.4999C45.2 12.4999 45.7 12.2999 46.2 11.7999C46.5 11.4999 46.7 11.0999 46.7 10.5999H44.5V9.7999H47.4V10.1999ZM52 7.6999H49.3V9.5999H51.8V10.2999H49.3V12.1999H52V12.9999H48.5V6.9999H52V7.6999ZM55.3 12.9999H54.5V7.6999H52.8V6.9999H57V7.6999H55.3V12.9999ZM59.9 12.9999V6.9999H60.7V12.9999H59.9ZM64.1 12.9999H63.3V7.6999H61.6V6.9999H65.7V7.6999H64L64.1 12.9999ZM73.6 12.1999C73 12.7999 72.3 13.0999 71.4 13.0999C70.5 13.0999 69.8 12.7999 69.2 12.1999C68.6 11.5999 68.3 10.8999 68.3 9.9999C68.3 9.0999 68.6 8.3999 69.2 7.7999C69.8 7.1999 70.5 6.8999 71.4 6.8999C72.3 6.8999 73 7.1999 73.6 7.7999C74.2 8.3999 74.5 9.0999 74.5 9.9999C74.5 10.8999 74.2 11.5999 73.6 12.1999ZM69.8 11.6999C70.2 12.0999 70.8 12.3999 71.4 12.3999C72 12.3999 72.6 12.1999 73 11.6999C73.4 11.2999 73.7 10.6999 73.7 9.9999C73.7 9.2999 73.5 8.6999 73 8.2999C72.6 7.8999 72 7.5999 71.4 7.5999C70.8 7.5999 70.2 7.7999 69.8 8.2999C69.4 8.6999 69.1 9.2999 69.1 9.9999C69.1 10.6999 69.3 11.2999 69.8 11.6999ZM75.6 12.9999V6.9999H76.5L79.4 11.6999V6.9999H80.2V12.9999H79.4L76.3 8.0999V12.9999H75.6Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M68.1 21.8001C65.7 21.8001 63.8 23.6001 63.8 26.1001C63.8 28.5001 65.7 30.4001 68.1 30.4001C70.5 30.4001 72.4 28.6001 72.4 26.1001C72.4 23.5001 70.5 21.8001 68.1 21.8001ZM68.1 28.6001C66.8 28.6001 65.7 27.5001 65.7 26.0001C65.7 24.5001 66.8 23.4001 68.1 23.4001C69.4 23.4001 70.5 24.4001 70.5 26.0001C70.5 27.5001 69.4 28.6001 68.1 28.6001ZM58.8 21.8001C56.4 21.8001 54.5 23.6001 54.5 26.1001C54.5 28.5001 56.4 30.4001 58.8 30.4001C61.2 30.4001 63.1 28.6001 63.1 26.1001C63.1 23.5001 61.2 21.8001 58.8 21.8001ZM58.8 28.6001C57.5 28.6001 56.4 27.5001 56.4 26.0001C56.4 24.5001 57.5 23.4001 58.8 23.4001C60.1 23.4001 61.2 24.4001 61.2 26.0001C61.2 27.5001 60.1 28.6001 58.8 28.6001ZM47.7 23.1001V24.9001H52C51.9 25.9001 51.5 26.7001 51 27.2001C50.4 27.8001 49.4 28.5001 47.7 28.5001C45 28.5001 43 26.4001 43 23.7001C43 21.0001 45.1 18.9001 47.7 18.9001C49.1 18.9001 50.2 19.5001 51 20.2001L52.3 18.9001C51.2 17.9001 49.8 17.1001 47.8 17.1001C44.2 17.1001 41.1 20.1001 41.1 23.7001C41.1 27.3001 44.2 30.3001 47.8 30.3001C49.8 30.3001 51.2 29.7001 52.4 28.4001C53.6 27.2001 54 25.5001 54 24.2001C54 23.8001 54 23.4001 53.9 23.1001H47.7ZM93.1 24.5001C92.7 23.5001 91.7 21.8001 89.5 21.8001C87.3 21.8001 85.5 23.5001 85.5 26.1001C85.5 28.5001 87.3 30.4001 89.7 30.4001C91.6 30.4001 92.8 29.2001 93.2 28.5001L91.8 27.5001C91.3 28.2001 90.7 28.7001 89.7 28.7001C88.7 28.7001 88.1 28.3001 87.6 27.4001L93.3 25.0001L93.1 24.5001ZM87.3 25.9001C87.3 24.3001 88.6 23.4001 89.5 23.4001C90.2 23.4001 90.9 23.8001 91.1 24.3001L87.3 25.9001ZM82.6 30.0001H84.5V17.5001H82.6V30.0001ZM79.6 22.7001C79.1 22.2001 78.3 21.7001 77.3 21.7001C75.2 21.7001 73.2 23.6001 73.2 26.0001C73.2 28.4001 75.1 30.2001 77.3 30.2001C78.3 30.2001 79.1 29.7001 79.5 29.2001H79.6V29.8001C79.6 31.4001 78.7 32.3001 77.3 32.3001C76.2 32.3001 75.4 31.5001 75.2 30.8001L73.6 31.5001C74.1 32.6001 75.3 34.0001 77.4 34.0001C79.6 34.0001 81.4 32.7001 81.4 29.6001V22.0001H79.6V22.7001ZM77.4 28.6001C76.1 28.6001 75 27.5001 75 26.0001C75 24.5001 76.1 23.4001 77.4 23.4001C78.7 23.4001 79.7 24.5001 79.7 26.0001C79.7 27.5001 78.7 28.6001 77.4 28.6001ZM101.8 17.5001H97.3V30.0001H99.2V25.3001H101.8C103.9 25.3001 105.9 23.8001 105.9 21.4001C105.9 19.0001 103.9 17.5001 101.8 17.5001ZM101.9 23.5001H99.2V19.2001H101.9C103.3 19.2001 104.1 20.4001 104.1 21.3001C104 22.4001 103.2 23.5001 101.9 23.5001ZM113.4 21.7001C112 21.7001 110.6 22.3001 110.1 23.6001L111.8 24.3001C112.2 23.6001 112.8 23.4001 113.5 23.4001C114.5 23.4001 115.4 24.0001 115.5 25.0001V25.1001C115.2 24.9001 114.4 24.6001 113.6 24.6001C111.8 24.6001 110 25.6001 110 27.4001C110 29.1001 111.5 30.2001 113.1 30.2001C114.4 30.2001 115 29.6001 115.5 29.0001H115.6V30.0001H117.4V25.2001C117.2 23.0001 115.5 21.7001 113.4 21.7001ZM113.2 28.6001C112.6 28.6001 111.7 28.3001 111.7 27.5001C111.7 26.5001 112.8 26.2001 113.7 26.2001C114.5 26.2001 114.9 26.4001 115.4 26.6001C115.2 27.8001 114.2 28.6001 113.2 28.6001ZM123.7 22.0001L121.6 27.4001H121.5L119.3 22.0001H117.3L120.6 29.6001L118.7 33.8001H120.6L125.7 22.0001H123.7ZM106.9 30.0001H108.8V17.5001H106.9V30.0001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M10.4 7.5C10.1 7.8 10 8.3 10 8.9V31C10 31.6 10.2 32.1 10.5 32.4L10.6 32.5L23 20.1V19.9L10.4 7.5Z",
    fill: "url(#paint0_linear_135_1397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M27 24.2998L22.9 20.1998V19.8998L27 15.7998L27.1 15.8998L32 18.6998C33.4 19.4998 33.4 20.7998 32 21.5998L27 24.2998Z",
    fill: "url(#paint1_linear_135_1397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M27.1 24.2L22.9 20L10.4 32.5C10.9 33 11.6 33 12.5 32.6L27.1 24.2Z",
    fill: "url(#paint2_linear_135_1397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.1 15.8001L12.5 7.50011C11.6 7.00011 10.9 7.10011 10.4 7.60011L22.9 20.0001L27.1 15.8001Z",
    fill: "url(#paint3_linear_135_1397)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    d: "M27 24.1001L12.5 32.3001C11.7 32.8001 11 32.7001 10.5 32.3001L10.4 32.4001L10.5 32.5001C11 32.9001 11.7 33.0001 12.5 32.5001L27 24.1001Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.12,
    d: "M10.4 32.3C10.1 32 10 31.5 10 30.9V31C10 31.6 10.2 32.1 10.5 32.4V32.3H10.4ZM32 21.3L27 24.1L27.1 24.2L32 21.4C32.7 21 33 20.5 33 20C33 20.5 32.6 20.9 32 21.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.25,
    d: "M12.5 7.5998L32 18.6998C32.6 19.0998 33 19.4998 33 19.9998C33 19.4998 32.7 18.9998 32 18.5998L12.5 7.5998C11.1 6.6998 10 7.2998 10 8.8998V8.9998C10 7.4998 11.1 6.7998 12.5 7.5998Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_135_1397",
    x1: 21.795,
    y1: 8.705,
    x2: 5.012,
    y2: 25.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_135_1397",
    x1: 33.834,
    y1: 20.0498,
    x2: 9.63699,
    y2: 20.0498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_135_1397",
    x1: 24.816,
    y1: 22.285,
    x2: 2.05799,
    y2: 45.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_135_1397",
    x1: 7.26099,
    y1: 0.212112,
    x2: 17.424,
    y2: 10.3751,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_1397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppStoreGoogle4D63C31A3E);
export default __webpack_public_path__ + "static/media/app-store-google-4d63c31a3e.3045cef2a89935633017989ec838aad9.svg";
export { ForwardRef as ReactComponent };